import React from 'react';

import {LiveStreamingModuleController} from "../live-streaming-module.controller";
import {LiveStreamingModuleProps} from "../models/live-streaming-module.props";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {LiveStreamingModuleButton} from "./live-streaming-module-button";
import {APP} from "../../../../../core/app/consts";
import {WIDGET_TYPES} from "../../../../../core/consts";
import {StringToJsx} from "../../../../../core/components/string-to-jsx";
import classNames from "classnames";
import {LiveStreamingModuleBookmaker} from "./live-streaming-module.bookmaker";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";

export class LiveStreamingModuleComponentProps extends LiveStreamingModuleProps {
}

export const LiveStreamingModuleComponent = ({controller}: LiveStreamingModuleComponentProps) => {
  const {state} = controller;
  const {device} = state;

  const containerProps = {
    className: classNames('live-streaming-module', {'live-streaming-module-small-view': device.isSmallView})
  }

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    gameId: controller.state.gameId,
    status: controller.state.statusGroup,
    bookieId: controller.state.bookmakerId,
    bookieName: controller.state.bookmakerName,
    urlLink: controller.state.bookmakerLink,
    stripType: controller.state.stripColorMode,
    impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.main,
    widgetType: WIDGET_TYPES.liveStream,
    source: APP.ANALYTICS.SOURCES.liveStreaming
  });

  return (
    <div {...containerProps}>
      <LiveStreamingModuleBookmaker controller={controller}/>
      <div className={'live-streaming-module-diagonal-line'}/>
      <div className={'live-streaming-module-text'}>
        <StringToJsx domString={controller.state.watchLiveSpan}/>
      </div>
      <LiveStreamingModuleButton onClick={() => onBookieClick()} bookieHrefModel={bookieHrefModel}/>
    </div>
  )
};

const settings: ComposeSettings = {
  component: LiveStreamingModuleComponent,
  propsType: LiveStreamingModuleComponentProps,
  controllerType: LiveStreamingModuleController,

  createModule: true,
  observe: true,

};

export const LiveStreamingModule = Compose(settings);

